/** #/admin — the users table as a full page. Layout only; AdminUsers does the work. */
import { AdminUsers } from './AdminUsers';

export function AdminScreen({ onClose }: { onClose: () => void }) {
  return (
    <div className="flags-page">
      <div className="container flags-inner">
        <header className="flags-head">
          <div>
            <h1>Users &amp; registrations</h1>
            <p>Approve, reject and assign roles.</p>
          </div>
          <button onClick={onClose}>← Back to site</button>
        </header>
        <AdminUsers />
      </div>
    </div>
  );
}
